import styles from "./index.module.scss";
import Image from "@/components/Atoms/Image";
import { ListRow } from "@/components/Atoms/List";
import { Item } from "@/components/Atoms/Item";
import CustomLink from "@/components/Atoms/CustomLink";
import { FeaturedWarning } from "@/components/Atoms/Paragraph";
import GeoWrapper from "../GeoConditional";

interface Props {
  data?: any;
  route: string;
}

export default function Footer({ data, route }: Props) {
  const footer = data ?? {};
  const year = new Date().getFullYear();
  const footerContent =
    typeof footer.footerContent === "string"
      ? footer.footerContent.replace(/\{year\}/, String(year))
      : null;
  const footerLinks = footer.links ?? [];

  const style = {
    "--bg": footer.footerBackgroundColor?.color?.hex,
    "--color": footer.footerTextColor?.color?.hex,
  } as React.CSSProperties;

  const standardColor = { color: { hex: "#000" } };

  return (
    <footer
      style={style as React.CSSProperties}
      className={` z-10 ${
        footer.addSpacer && route != "/age-gate" ? "pt-12" : "pt-4"
      } w-full ${styles.footer}  ${
        route != "/age-gate" ? "relative" : "relative pt-2  bottom-0"
      }`}
    >
      {route != "/age-gate" ? (
        <>
          {footer.addSpacer && footer.spacerLogo && (
            <div
              style={style as React.CSSProperties}
              className={` ${styles.logoSpacer}   w-full h-4 absolute translate-y-[-100%] flex flex-row justify-center `}
            >
              <Image data={footer.spacerLogo} />
            </div>
          )}

          <div
            className={` ${
              footer.navigationLinksAlign == "left"
                ? "justify-between"
                : "justify-center "
            } container mx-auto w-full flex gap-12 flex-col lg:flex-row border-b border-solid border-white/20 py-4 lg:py-2  `}
          >
            {footer.hasSocial && (
              <div
                className={`${
                  footer.navigationLinksAlign == "left"
                    ? "hidden"
                    : "hidden lg:flex min-w-[5rem]"
                }`}
              ></div>
            )}
            <div className="flex flex-col  justify-center items-center gap-4">
              <ListRow tag={""} style={footer.navigationLinksAlign}>
                {footer.hasNav && (footer.navLinks?.length ?? 0) > 0 && (
                  <>
                    {footer.navLinks.map((entry: any, i: number) => (
                      <Item
                        className="brandNavFooter"
                        style="noWrap"
                        key={i}
                        data={entry}
                        color={undefined}
                      />
                    ))}
                  </>
                )}
                <GeoWrapper
                  initial={footer.countryAvailability}
                  country={footer.countries}
                  list={footer.listOfCountries}
                >
                  {" "}
                  {footer.addBuyCta && footer.ctaLink && (
                    <a
                      className="brandCall"
                      style={{ color: footer.ctaColor?.color?.hex }}
                      href={footer.ctaLink}
                      target="_blank"
                    >
                      {footer.ctaLabel?.label}
                    </a>
                  )}
                </GeoWrapper>
              </ListRow>
              {footer.regulationFile?.url && (
                <a
                  href={footer.regulationFile.url}
                  className="brandNavFooter"
                  target="_blank"
                >
                  {footer.contestLabel?.label}
                </a>
              )}
            </div>

            {footer.hasSocial && (footer.socialLinks?.length ?? 0) > 0 && (
              <div className=" xs:flex-col xs:justify-center xs:gap-y-6 flex-row justify-around mt-4 mb-6 min-w-[5rem] ">
                <span
                  className={
                    footer.socialIconsDisplay === "mobile"
                      ? "flex  lg:hidden"
                      : footer.socialIconsDisplay === "desktop"
                      ? "hidden lg:flex"
                      : "flex"
                  }
                >
                  <ListRow style="fixedRow" tag={""}>
                    {footer.socialLinks.map((entry: any, i: number) => {
                      const iconStyle = {
                        "--color": footer.footerTextColor?.color?.hex,
                        "--svg": `url(${entry.image?.url})`,
                      } as React.CSSProperties;
                      return entry.swapImage ? (
                        <CustomLink
                          target="_blank"
                          key={i}
                          href={`${entry.externalUrl}`}
                          external={"true"}
                        >
                          <div
                            style={iconStyle as React.CSSProperties}
                            className={
                              footer.overwriteSocialIconsColor
                                ? styles.socialIcon
                                : styles.socialIconDefault
                            }
                          ></div>
                        </CustomLink>
                      ) : (
                        <Item
                          style="noWrap"
                          key={i}
                          data={entry}
                          color={undefined}
                        />
                      );
                    })}
                  </ListRow>
                </span>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="container mx-auto w-full flex gap-12 flex-col lg:flex-row border-b border-solid border-white/20 py-4 lg:py-2 ">
          <ListRow tag={""} style={footer.navigationLinksAlign}>
            {footer.hasNav && (footer.navLinks?.length ?? 0) > 0 && (
              <>
                {footer.navLinks
                  .filter(
                    (x: any) =>
                      x.slug == "privacy-policy" ||
                      x.slug == "terms-conditions" ||
                      x.slug == "terms-and-conditions-of-use"
                  )
                  .map((entry: any, i: number) => (
                    <Item
                      className="brandNavFooter"
                      style="noWrap"
                      key={i}
                      data={entry}
                      color={undefined}
                    />
                  ))}
              </>
            )}
          </ListRow>
        </div>
      )}

      <div className="flex flex-col-reverse lg:flex-row w-full justify-between container mx-auto items-center py-2 ">
        {footerContent ? (
          <div>
            <div className="text-center md:text-left brandNavFooter mb-1">
              {footerContent}
            </div>
          </div>
        ) : (
          <div />
        )}
        <div className="hidden lg:flex mb-12 md:mb-0 flex-col items-center md:flex-row gap-6 lg:gap-16">
          {footerLinks.map((entry: any, i: number) => {
            if (entry.externalLink) {
              return (
                <a
                  key={i}
                  target={entry.newWindow && "_blank"}
                  href={entry.externalUrl}
                >
                  <Image className="max-w-[8rem]" data={entry.image} />
                </a>
              );
            } else {
              <Image key={i} data={entry.image} />;
            }
          })}
        </div>
        {footerLinks.length > 0 && (
          <div className="flex lg:hidden mb-12 md:mb-0 flex-col items-center  md:flex-row gap-12  py-6">
            {footerLinks[3]?.image && (
              <a
                className="flex flex-col-reverse justify-center items-center gap-4 max-w-[10.5rem]"
                target={footerLinks[3]?.newWindow && "_blank"}
                href={footerLinks[3]?.externalUrl}
              >
                <Image className="max-w-[10rem]" data={footerLinks[3]?.image} />
              </a>
            )}
            <div className="flex flex-row gap-6">
              {footerLinks[1]?.image && (
                <a
                  className="flex flex-col-reverse justify-center items-center gap-4 max-w-[10.5rem]"
                  target={footerLinks[1]?.newWindow && "_blank"}
                  href={footerLinks[1]?.externalUrl}
                >
                  <Image className="max-w-[10rem]" data={footerLinks[1]?.image} />
                </a>
              )}
              {footerLinks[2]?.image && (
                <a
                  className="flex flex-col-reverse justify-center items-center gap-4 max-w-[10.5rem]"
                  target={footerLinks[2]?.newWindow && "_blank"}
                  href={footerLinks[2]?.externalUrl}
                >
                  <Image className="max-w-[10rem]" data={footerLinks[2]?.image} />
                </a>
              )}
            </div>
            {footerLinks[0]?.image && (
              <a
                className="flex flex-col-reverse justify-center items-center gap-4 max-w-[10.5rem]"
                target={footerLinks[0]?.newWindow && "_blank"}
                href={footerLinks[0]?.externalUrl}
              >
                <Image className="max-w-[10rem]" data={footerLinks[0]?.image} />
              </a>
            )}
          </div>
        )}
      </div>
      {footer.disclaimer?.label && (
        <div className="flex   bg-white justify-center py-2">
          <FeaturedWarning
            copy={footer.disclaimer.label}
            color={standardColor?.color}
            layout={undefined}
          />
        </div>
      )}
    </footer>
  );
}
